export default __webpack_public_path__ + "static/media/m_events.e361267b.png";